import { render, staticRenderFns } from "./NextShop.vue?vue&type=template&id=7f20a0d8&scoped=true"
import script from "./NextShop.vue?vue&type=script&lang=js"
export * from "./NextShop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f20a0d8",
  null
  
)

export default component.exports